"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAttributeFilterProps = exports.getElementKey = exports.getElementTitles = exports.getElementTitle = exports.isLimitingAttributeFiltersEmpty = exports.throwMissingCallbackError = exports.ThrowMissingComponentError = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * @internal
 */
exports.ThrowMissingComponentError = function (componentName, providerName) { return function () {
    throw new sdk_ui_1.UnexpectedSdkError("Component: " + componentName + " is missing in the " + providerName + ".");
}; };
/**
 * @internal
 */
exports.throwMissingCallbackError = function (callbackName, providerName) {
    return function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
        throw new sdk_ui_1.UnexpectedSdkError("Callback: " + callbackName + " is missing in the " + providerName + ".");
    };
};
/**
 * @internal
 */
function isLimitingAttributeFiltersEmpty(limitingAttributeFilters) {
    return (isEmpty_1.default(limitingAttributeFilters) ||
        limitingAttributeFilters.every(function (limitingAttributeFilter) {
            return sdk_model_1.isNegativeAttributeFilter(limitingAttributeFilter.attributeFilter)
                ? sdk_model_1.attributeElementsIsEmpty(sdk_model_1.filterAttributeElements(limitingAttributeFilter.attributeFilter))
                : false;
        }));
}
exports.isLimitingAttributeFiltersEmpty = isLimitingAttributeFiltersEmpty;
/**
 * @internal
 */
function getElementTitle(element, intl) {
    return element.formattedTitle || element.title || "(" + intl.formatMessage({ id: "empty_value" }) + ")";
}
exports.getElementTitle = getElementTitle;
/**
 * @internal
 */
function getElementTitles(elements, intl) {
    return elements.map(function (el) { return getElementTitle(el, intl); }).join(", ");
}
exports.getElementTitles = getElementTitles;
/**
 * @internal
 */
function getElementKey(element) {
    return element.uri;
}
exports.getElementKey = getElementKey;
/**
 * @internal
 */
function validateAttributeFilterProps(props) {
    var _a, _b;
    var connectToPlaceholder = props.connectToPlaceholder, filter = props.filter, identifier = props.identifier, onApply = props.onApply, parentFilters = props.parentFilters, hiddenElements = props.hiddenElements, staticElements = props.staticElements, backend = props.backend;
    ts_invariant_1.default(!(filter && connectToPlaceholder), "It's not possible to combine 'filter' property with 'connectToPlaceholder' property. Either provide a filter, or a placeholer.");
    ts_invariant_1.default(!(filter && !onApply), "It's not possible to use 'filter' property without 'onApply' property. Either provide 'onApply' callback or use placeholders.");
    //deprecated identifier check
    ts_invariant_1.default(!(filter && identifier), "It's not possible to combine 'identifier' property with 'filter' property. Either provide an identifier, or a filter.");
    ts_invariant_1.default(!(identifier && !onApply), "It's not possible to use 'identifier' property without 'onApply' property. Either provide 'onApply' callback or use placeholders.");
    ts_invariant_1.default(!(identifier && connectToPlaceholder), "It's not possible to combine 'identifier' property with 'connectToPlaceholder' property. Either provide a idenfifier, or a placeholder.");
    ts_invariant_1.default(identifier || filter || connectToPlaceholder, "No identifier, filter or placeholer provided. Provide one of the properties: 'filter', 'connectToPlaceholder' or 'identifier' (note that identifier is deprecated).");
    ts_invariant_1.default(!(!((_a = backend === null || backend === void 0 ? void 0 : backend.capabilities) === null || _a === void 0 ? void 0 : _a.supportsElementsQueryParentFiltering) && !isEmpty_1.default(parentFilters)), "Parent filtering is not supported by the current backend implementation.");
    ts_invariant_1.default(!(!((_b = backend === null || backend === void 0 ? void 0 : backend.capabilities) === null || _b === void 0 ? void 0 : _b.supportsElementsQueryParentFiltering) &&
        !isEmpty_1.default(hiddenElements) &&
        isEmpty_1.default(staticElements)), "Hidden elements are not supported by the current backend implementation.");
    if (identifier) {
        console.warn("Definition of an attribute display form using 'identifier' is deprecated, use 'filter' property instead. Please see the documentation of [AttributeFilter component](https://sdk.gooddata.com/gooddata-ui/docs/attribute_filter_component.html) for further details.");
    }
}
exports.validateAttributeFilterProps = validateAttributeFilterProps;
//# sourceMappingURL=utils.js.map